"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTableRowHeight = exports.getTableCellPaddingY = void 0;
const getTableCellPaddingY = tableDensity => {
  switch (tableDensity) {
    case 'comfortable':
      return '16px';
    case 'compact':
      return '12px';
    case 'roomy':
      return '20px';
  }
};
exports.getTableCellPaddingY = getTableCellPaddingY;
const getTableRowHeight = tableDensity => {
  switch (tableDensity) {
    case 'comfortable':
      return '52px';
    case 'compact':
      return '36px';
    case 'roomy':
      return '60px';
  }
};
exports.getTableRowHeight = getTableRowHeight;